export const PRODUCT_CARD_IMPRESSION = {
    url: '/trk/commerce:product_card_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const CLICK_PRODUCT_CARD = {
    url: '/trk/commerce:click_product_card',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_ADD_TO_CART = {
    url: '/trk/commerce:click_add_to_cart',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_CHECKOUT = {
    url: '/trk/commerce:click_checkout',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_DECREASE_IN_CART_CLICK = {
    url: '/trk/commerce:click_decrease_in_cart',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_INCREASE_IN_CART_CLICK = {
    url: '/trk/commerce:click_increase_in_cart',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_MORE_DESCRIPTION = {
    url: '/trk/commerce:click_more_description',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_PRODUCT_DESCRIPTION_PAGE_LINK = {
    url: '/trk/commerce:click_pdp_link',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_REMOVE_IN_CART_CLICK = {
    url: '/trk/commerce:click_remove_in_cart',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_SHOPPING_BAG = {
    url: '/trk/commerce:click_shopping_bag',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_SHOPPING_CART = {
    url: '/trk/commerce:click_shopping_cart',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_UNIT_OPTION_FULL = {
    url: '/trk/commerce:click_unit_option_full',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_UNIT_OPTION_SUMMARY = {
    url: '/trk/commerce:click_unit_option_summary',
    isUserEngagement: true,
    consent: 'essential',
};
export const DISMISS_PRODUCT_SUMMARY = {
    url: '/trk/commerce:dismiss_product_summary',
    isUserEngagement: true,
    consent: 'essential',
};
export const SHOW_PRODUCT_DETAIL = {
    url: '/trk/commerce:product_detail_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const HIGHLIGHTED_PRODUCT_IMPRESSION = {
    url: '/trk/commerce:highlighted_product_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const HIGHLIGHTED_PRODUCT_CLICK = {
    url: '/trk/commerce:click_highlighted_product',
    isUserEngagement: true,
    consent: 'essential',
};
export const CLICK_PRODUCT_LIST_ITEM = {
    url: '/trk/commerce:click_product_list_item',
    isUserEngagement: true,
    consent: 'essential',
};
export const PRODUCT_LIST_ITEM_IMPRESSION = {
    url: '/trk/commerce:product_list_item_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const COMMERCE_IMPRESSION_CUSTOM_CTA = {
    url: '/trk/commerce:custom_cta_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const COMMERCE_CLICK_CUSTOM_CTA = {
    url: '/trk/commerce:custom_cta_click',
    isUserEngagement: true,
    consent: 'essential',
};
export const COMMERCE_OPEN_PRODUCT_LIST = {
    url: '/trk/commerce:open_product_list',
    isUserEngagement: true,
    consent: 'essential',
};
export const COMMERCE_CLOSE_PRODUCT_LIST = {
    url: '/trk/commerce:close_product_list',
    isUserEngagement: true,
    consent: 'essential',
};
/**
 * Note: Adding an endpoint to this file requires update to
 * the Jira docs https://fwn.atlassian.net/wiki/x/SQAELQ
 */
